import styled from "styled-components";

export const GroupRadioOptionWrapper = styled.div`
  margin-bottom: 40px;
`;
